require('./bootstrap');

import Vue from "vue";
import VueMeta from "vue-meta";
import { App as InertiaApp, plugin as InertiaPlugin } from '@inertiajs/inertia-vue';
import {InertiaProgress} from '@inertiajs/progress/src'
import store from "@/core/services/store";
import Modalable from "@/view/layout/modal/Modalable"
import ToModal from "@/view/layout/modal/ToModal"
import PortalVue from "portal-vue";
import ClipboardJS from "clipboard";

// Global 3rd party plugins
import "popper.js";
import "tooltip.js";
import PerfectScrollbar from "perfect-scrollbar";
import VueSweetalert2 from 'vue-sweetalert2';

Vue.config.productionTip = false;
window.PerfectScrollbar = PerfectScrollbar;
window.ClipboardJS = ClipboardJS;

Vue.use(VueSweetalert2);
Vue.use(InertiaPlugin);
Vue.mixin({ methods: { route } });
Vue.component("Modalable", Modalable);
Vue.component("ToModal", ToModal);
Vue.use(PortalVue);
Vue.use(VueMeta);

Vue.mixin(require('./base'))

// Vue 3rd party plugins
import i18n from "@/core/plugins/vue-i18n";
import "@/core/plugins/portal-vue";
import "@/core/plugins/bootstrap-vue";
import "@/core/plugins/perfect-scrollbar";
import "@/core/plugins/highlight-js";
import "@/core/plugins/inline-svg";
import "@/core/plugins/treeselect";
import "@/core/plugins/metronic";
import "sweetalert2/dist/sweetalert2.min.css";

InertiaProgress.init()

const el = document.getElementById('app')

new Vue({
    store,
    i18n,
    render: h =>
        h(InertiaApp, {
            props: {
                initialPage: JSON.parse(el.dataset.page),
                resolveComponent: name => import(`@/view/pages/${name}`).then(module => module.default),
                resolveErrors: page => (page.props.errors || {}),
            },
        }),
}).$mount(el);

